export function documentDownloadUrl(documentId: string) {
  return `${process.env.API_URL}/api/v2/documents/${documentId}/download`;
}
